// src/components/icons.tsx
import React from "react";

// Feather
import { FiUserCheck, FiInfo, FiPhone, FiTarget, FiFile } from "react-icons/fi";
// Material
import {
  MdGroups,
  MdSchool,
  MdAssessment,
  MdBarChart,
  MdCheckCircle,
  MdStorage,
  MdAttachMoney,
  MdFolderShared,
  MdDirectionsCar,
} from "react-icons/md";
// Font Awesome 6
import {
  FaCalendarDays,
  FaMoneyBillWave,
  FaHandHoldingHeart,
  FaSackDollar,
  FaLeaf,
} from "react-icons/fa6";
// Octicons
import { GoTasklist } from "react-icons/go";
// Ionicons
import { IoHelpCircleOutline } from "react-icons/io5";

export const iconsMap: Record<string, React.ReactNode> = {
  attendance: <FiUserCheck />,
  team: <MdGroups />,
  courses: <MdSchool />,
  information: <FiInfo />,
  contacts: <FiPhone />,
  objectives: <FiTarget />,
  evaluation: <MdAssessment />,
  indicators: <MdBarChart />,
  approvals: <MdCheckCircle />,

  // // we had this before:
  leaves: <FaLeaf />,

  // // ✅ add the alias you’re calling elsewhere:
  palmTree: <FaLeaf />,

  cars: <MdDirectionsCar />,
  resources: <MdStorage />,
  expenses: <FaMoneyBillWave />,
  advances: <MdAttachMoney />,
  documents: <FiFile />,
  benefits: <FaHandHoldingHeart />,
  salary: <FaSackDollar />,
  dossary: <MdFolderShared />,
  timesheet: <FaCalendarDays />,
  tasks: <GoTasklist />,
  default: <IoHelpCircleOutline />,
};
